<div class="agent-request-container">

  <mat-card id="page-container">
   
    <mat-card-title >
      <h2 class="card-title">Commission Discrepancy Form</h2>
    </mat-card-title>

    <div class="mat-card-body-container">

      <form [formGroup]="agentResourceForm" novalidate  class="card-content">      

      <div class="mat-card-body-center">      
        
        <div class="AgencyInfo">
          <span class="label1">
            <label><h3><strong>Agency ID:</strong></h3></label>
          </span>
          <span class="label2">
            <label><h3><strong>{{this.agencyID}}</strong></h3></label>           
          </span>
          <br>
          <span class="label1">
            <label><h3><strong>Agency name:</strong></h3></label>
          </span>
          <span class="label2">
            <label><h3><strong>{{this.agencyName}}</strong></h3></label>            
          </span>
        </div>
        <br>   
              <!--
              <br>
              <label><h3><strong>Agency ID: {{applicationID}}</strong></h3></label>  
              <label><h3><strong>Agency Name: {{agencyName}}</strong></h3></label>  
              <br>   
              -->
                 

              <mat-form-field appearance="outline" class="half-width">
                <mat-select matNativeControl placeholder="Agent Name" required formControlName="agentNameListCtrl">
                  <ng-container *ngFor="let agent of agentsList">
                    <mat-option  [value]="agent.Agent_Name">
                      {{ agent.Agent_Name }}
                    </mat-option>
                  </ng-container>                
                  </mat-select>
              </mat-form-field>
                          
            
              <mat-form-field appearance="outline" class="quarter-width">
                  <mat-label>Student Number</mat-label>
                  <input matInput placeholder="Student Number" formControlName="studentNumberCtrl" required readonly >                 
              </mat-form-field>                                

              <mat-form-field appearance="outline" class="quarter-width">
                <mat-label>Application Number</mat-label>
                <input matInput placeholder="Application Number" formControlName="applicationNumberCtrl" required readonly >               
              </mat-form-field>             

              <mat-form-field appearance="outline" class="quarter-width">
              <mat-select matNativeControl placeholder="Term" required formControlName="termCtrl">
                <ng-container *ngFor="let term of termsList">
                  <mat-option  [value]="term.Term">
                    {{ term.Name }}
                  </mat-option>
                </ng-container>
             
                </mat-select>
              </mat-form-field>                                  

              <mat-form-field appearance="outline" class="half-width">
                <mat-label>Student Last Name</mat-label>
                  <input matInput placeholder="Student Last Name" formControlName="studentLastNameCtrl" required readonly >                 
              </mat-form-field>
              
              <mat-form-field appearance="outline" class="half-width">
                <mat-label>Student First Name</mat-label>
                <input matInput placeholder="Student First Name" formControlName="studentFirstNameCtrl" required readonly >               
              </mat-form-field>              

              <mat-form-field appearance="outline" class="quarter-width">
                <mat-label>Program Code</mat-label>
                <input matInput placeholder="Program Code" formControlName="programCodeCtrl" required readonly >             
              </mat-form-field>                               

              <mat-form-field appearance="outline" class="half-width">
                <mat-label>Program Name</mat-label>
                <input matInput placeholder="Program Name" formControlName="programNameCtrl" required readonly >               
              </mat-form-field>            
                            
              <mat-form-field appearance="outline" class="quarter-width">
                <mat-select matNativeControl placeholder="Campus" required formControlName="campusCtrl">
                  <ng-container *ngFor="let campus of programCampusesList">
                    <mat-option  [value]="campus.Campus_DESC">
                      {{ campus.Campus_DESC }}
                    </mat-option>
                  </ng-container>                
                  </mat-select>
                </mat-form-field>                  
                
                <mat-form-field appearance="outline" class="quarter-width">
                  <mat-label>Tuition Amount ($ CAD)</mat-label>
                  <input matInput  type="number" class="example-right-align" placeholder="Tuition Amount *" formControlName="tuitionAmountCtrl" required readonly >        
                </mat-form-field>  

              <mat-form-field appearance="outline" class="quarter-width">
                <mat-label>Commission Amount ($ CAD)</mat-label>
                <input matInput type="number" class="example-right-align" placeholder="Commission Amount *" formControlName="commissionAmountCtrl" required readonly >                                
              </mat-form-field>              

              <mat-form-field appearance="outline" class="quarter-width">
                <mat-label>Commission Status</mat-label>               
                <input matInput  placeholder="Commission Status *" formControlName="commissionStatusCtrl" required readonly >                 
              </mat-form-field>              

              <mat-form-field appearance="outline" class="quarter-width">
                <mat-label>Tuition Amount</mat-label>
                  <input matInput placeholder="Tuition Amount *" formControlName="tuitionAmountCtrl2" readonly>
                  <mat-error *ngIf="agentResourceForm.get('tuitionAmountCtrl2').hasError('required')"><em class="error-hint">Required</em> </mat-error>
                  <mat-error *ngIf="agentResourceForm.get('tuitionAmountCtrl2').hasError('pattern')"><em class="error-hint"> Invalid tuition amount</em> </mat-error>                               
              </mat-form-field>

              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Comments (optional)</mat-label>
                <textarea matInput placeholder="Comments (optional)" formControlName="commentsCtrl" maxlength="500" readonly></textarea>    
                      
              </mat-form-field>
              <div class="mat-form-field">
                <mat-label>Max 500 characters</mat-label><mat-label class="rightFlex"> {{ differenceLength | async }} / 500</mat-label>
              </div>                 
                   
            <div class="mat-card-body-bottom-item">
              
              <div class="right-buttons">
                
                <button mat-stroked-button class="is-rounded red" color="primary" (click)="onCancel()">
                  <span>Cancel</span>
                </button>

              </div>
           
            </div>

        </div>

      </form>

    </div>
  
  </mat-card>

</div>
